// ═══════════════════════════════════════════════════════════
// Date Formatting — Shared utilities
// ═══════════════════════════════════════════════════════════

import { format, formatDistanceToNow, isValid, parseISO } from 'date-fns';

function parse(input: string | Date | null | undefined): Date | null {
  if (!input) return null;
  const d = typeof input === 'string' ? parseISO(input) : input;
  return isValid(d) ? d : null;
}

/** Format: Apr 22, 2026 */
export function fmtDate(input: string | Date | null | undefined): string {
  const d = parse(input);
  return d ? format(d, 'MMM d, yyyy') : '—';
}

/** Format: Apr 22, 2026 2:30 PM */
export function fmtDateTime(input: string | Date | null | undefined): string {
  const d = parse(input);
  return d ? format(d, 'MMM d, yyyy h:mm a') : '—';
}

/** Format: "2 hours ago", "3 days ago" */
export function fmtRelative(input: string | Date | null | undefined): string {
  const d = parse(input);
  return d ? formatDistanceToNow(d, { addSuffix: true }) : '—';
}

/** Format: 2026-04-22 (for inputs) */
export function fmtISO(input: string | Date | null | undefined): string {
  const d = parse(input);
  return d ? format(d, 'yyyy-MM-dd') : '';
}

/** Format for datetime-local inputs: 2026-04-22T14:30 */
export function fmtDateTimeLocal(input: string | Date | null | undefined): string {
  const d = parse(input);
  return d ? format(d, "yyyy-MM-dd'T'HH:mm") : '';
}
